import { render, staticRenderFns } from "./memu-list.vue?vue&type=template&id=35e3fdec&scoped=true&"
import script from "./memu-list.vue?vue&type=script&lang=js&"
export * from "./memu-list.vue?vue&type=script&lang=js&"
import style0 from "./memu-list.vue?vue&type=style&index=0&id=35e3fdec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e3fdec",
  null
  
)

export default component.exports